const POSTER_MAP = {
  '上阳春': '上阳春.jpg',
  '今宵酒醒[重生]': '今宵酒醒[重生].jpg',
  '今日离港': '今日离港.jpg',
  '余情可待[重生]': '余情可待.png',
  '余生为期': '余生为期.jpg',
  '你我相爱，为民除害': '你我相爱，为民除害.jpg',
  '入迷': '入迷.jpg',
  '全世界都在等你心动': '全世界都在等你心动.jpg',
  '冰川渐暖': '冰川渐暖.png',
  '喂，我们闪婚吧': '喂，我们闪婚吧.jpg',
  '她属于我': '她属于我.jpg',
  '她的山，她的海': '她的山，她的海.jpg',
  '宝石商人和钻石小姐': '宝石商人和钻石小姐.png',
  '希望你，真的很快乐': '希望你，真的很快乐.png',
  '帮我拍拍': '帮我拍拍.png',
  '总有老师要请家长': '总有老师要请家长.png',
  '我亲爱的法医小姐': '我亲爱的法医小姐.jpg',
  '我比你危险': '我比你危险.png',
  '我系统，我老婆风傲天': '我系统，我老婆风傲天.jpg',
  '打卦': '打卦.jpg',
  '探虚陵现代篇': '探虚陵.png',
  '放肆[娱乐圈]': '放肆.jpg',
  '晚潮': '晚潮.png',
  '暗瘾（娱乐圈）': '暗瘾.jpg',
  '月光照不到': '月光照不到.jpg',
  '烧': '烧.jpg',
  '爱呢？在白云之上': '爱呢？在白云之上.jpg',
  '病美人师尊的千层套路': '病美人师尊的千层套路.jpg',
  '相思令': '相思令.jpg',
  '神龛': '神龛.png',
  '美色撩人': '美色撩人.jpg',
  '请嗑我和总监的cp': '请嗑我和总监的cp.jpg',
  '谢相': '谢相.jpg',
  '距离': '距离.jpg',
  '都什么年代了啊': '都什么年代了啊.jpg',
  '问棺': '问棺.jpg',
  '飘飘': '飘飘.jpg',
};

export function getDramaPoster(title) {
  const file = POSTER_MAP[title];
  if (!file) return null;
  return process.env.PUBLIC_URL + '/images/dramas/' + file;
}
